<template>
    <Link
        dusk="manufacturers-card"
        v-if="displaySetting === 'grid'"
        :href="route(isPriceBooks ? 'web.catalog.price-books.show' :'web.catalog.manufacturers.show', manufacturer.slug)"
        class="block w-full relative border group h-full border-gray-225 hover:border-black active:bg-gray-125 active:border-gray-125"
    >
        <div class="h-32 relative at768:h-44" aria-hidden="true">
            <img
                class="max-h-16 absolute inset-0 m-auto max-w-[80%]"
                :src="marketingAssetUrl(manufacturer.logo.external_id)"
                :alt="manufacturer.name"
            />
        </div>
        <div class="px-6 pb-6 overflow-hidden at1024:h-28">
            <h3 class="text-xl font-medium underline-offset-4 decoration-1 group-hover:underline">
                {{ manufacturer.name }}
            </h3>
            <p dusk="manufacturers-card-tags" v-if="manufacturer?.tags?.['vendor-category']?.length" class="text-gray-400 text-sm leading-5" aria-hidden="true">
                <span v-for="(tag, index) in manufacturer.tags['vendor-category']">
                    {{ tag.name }}<span v-if="index + 1 < manufacturer.tags['vendor-category']?.length">, </span>
                </span>
            </p>
        </div>
    </Link>

    <label
        v-else-if="displaySetting === 'select'"
        :for="manufacturer.slug + '-checkbox'"
        class="group flex gap-2 items-center p-4 relative hover:bg-gray-tier-4 active:bg-gray-tier-5 at600:items-center at1024:gap-6"
    >
        <input
            type="checkbox"
            :name="manufacturer.slug + '-checkbox'"
            :id="manufacturer.slug + '-checkbox'"
            v-model="manufacturer.selected"
            class="mt-1 at600:mt-0"
        />
        <span class="hidden at1024:w-44 at1024:flex at1024:justify-center">
            <img
                v-if="marketingAssetUrl(manufacturer.logo?.external_id)"
                class="max-h-24"
                :src="marketingAssetUrl(manufacturer.logo?.external_id)"
                :alt="manufacturer.name"
            />
        </span>
        <span>
            <span class="font-medium group-hover:underline">{{ manufacturer.name }}</span>
            <span
                class="block text-gray-400 text-sm"
                v-if="manufacturer.tags"
                aria-hidden="true"
            >
                <span v-for="(tag, index) in manufacturer.tags['vendor-category']">
                    {{ tag }}<span v-if="index + 1 < manufacturer.tags['vendor-category']?.length">, </span>
                </span>
            </span>
            <!--            <p>-->
            <!--                <Pin-->
            <!--                    v-if="user"-->
            <!--                    type="vendor"-->
            <!--                    :id="manufacturer.id"-->
            <!--                    :label="false"-->
            <!--                />-->
            <!--            </p>-->
        </span>
    </label>

    <Link
        v-else
        :href="route(isPriceBooks ? 'web.catalog.price-books.show' :'web.catalog.manufacturers.show', manufacturer.slug)"
        class="group flex items-center px-4 py-2 hover:bg-gray-125 active:bg-gray-150"
    >
        <div class="hidden at1024:flex items-center justify-center w-44 at1200:w-44 h-20 at1200:h-28 mr-4 shrink-0" aria-hidden="true">
            <img
                class="max-h-20 max-w-[140px]"
                :src="marketingAssetUrl(manufacturer.logo.external_id)"
                :alt="manufacturer.name"
            />
        </div>
        <div class="w-1/2 font-medium">
            <span class="hover:underline underline-offset-4">{{ manufacturer.name }}</span>
            <p class="text-gray-400 text-sm font-normal" aria-hidden="true">
                <span v-for="(tag, index) in manufacturer.tags['vendor-category']">
                    {{ tag.name }}<span v-if="index + 1 < manufacturer.tags['vendor-category']?.length">, </span>
                </span>
            </p>
        </div>
        <div class="flex items-center ml-auto gap-4 at1024:mr-8" aria-hidden="true">
            <span class="type-secondary whitespace-nowrap">
                {{ manufacturer.channels.find((channel) => channel?.pivot.type === 1)?.channel }}
            </span>
            <span class="hidden at1024:block w-8">
                <span class="hidden group-hover:block">
                    <BaseSvg name="icon-arrow-forward" />
                </span>
            </span>
        </div>
    </Link>
</template>

<script setup>
import { BaseSvg } from "@/Components";
import { inject } from "vue";
import { useAssetTransforms, useUser } from "@/Composables";
import { Link } from "@inertiajs/vue3";

const { marketingAssetUrl } = useAssetTransforms();

const { user } = useUser();

const route = inject("route");
defineProps(["manufacturer", "displaySetting","isPriceBooks"]);
const emit = defineEmits(["manufacturerSelected"]);
</script>
